var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#24A1DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9412 10.3731L22.9234 23.1727C22.6957 24.0761 22.1019 24.3009 21.2582 23.8753L16.66 20.828L14.4412 22.7471C14.1957 22.968 13.9903 23.1526 13.5171 23.1526L13.8475 18.941L22.3698 12.0152C22.7403 11.7181 22.2894 11.5535 21.7939 11.8506L11.2582 17.8168L6.72249 16.5401C5.73588 16.263 5.71802 15.6528 6.92784 15.2272L24.6689 9.08032C25.4903 8.80329 26.2091 9.24493 25.9412 10.3731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter2);
export default __webpack_public_path__ + "static/media/footer2.4f6717b8815f2f352cd3f8db9f23da5f.svg";
export { ForwardRef as ReactComponent };